"use strict";
'use es6';

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _immutable = require("immutable");

var _omit = _interopRequireDefault(require("transmute/omit"));

var _I18n = _interopRequireDefault(require("I18n"));

var _react = _interopRequireWildcard(require("react"));

var _emptyFunction = _interopRequireDefault(require("react-utils/emptyFunction"));

var _invariant = _interopRequireDefault(require("react-utils/invariant"));

var _atom = require("atom");

var _utils = require("reference-resolvers/utils");

var _ReferenceResolverType = _interopRequireDefault(require("reference-resolvers/schema/ReferenceResolverType"));

var _UIForm = _interopRequireDefault(require("UIComponents/form/UIForm"));

var _UIFormControl = _interopRequireDefault(require("UIComponents/legacy/UIFormControl"));

var _UIGridItem = _interopRequireDefault(require("UIComponents/grid/UIGridItem"));

var _UILink = _interopRequireDefault(require("UIComponents/link/UILink"));

var _UIList = _interopRequireDefault(require("UIComponents/list/UIList"));

var _UIPopover = _interopRequireDefault(require("UIComponents/tooltip/UIPopover"));

var _UITag = _interopRequireDefault(require("UIComponents/tag/UITag"));

var _UITextInput = _interopRequireDefault(require("UIComponents/input/UITextInput"));

var _ComponentMethods = require("customer-data-ui-utilities/component/ComponentMethods");

var _CompanyRecord = _interopRequireDefault(require("customer-data-objects/company/CompanyRecord"));

var _PropertyInputDomain = _interopRequireDefault(require("customer-data-properties/input/PropertyInputDomain"));

var propTypes = (0, _extends2.default)({
  propertyInputComponentConfig: _react.PropTypes.object.isRequired,
  onInvalidProperty: _react.PropTypes.func.isRequired,
  onSecondaryChange: _react.PropTypes.func.isRequired,
  resolver: _ReferenceResolverType.default.isRequired,
  secondaryChanges: _react.PropTypes.instanceOf(_immutable.Map),
  subject: _react.PropTypes.instanceOf(_CompanyRecord.default),
  subjectId: _react.PropTypes.string
}, _PropertyInputDomain.default.propTypes);
var defaultProps = (0, _extends2.default)({
  onInvalidProperty: _emptyFunction.default,
  secondaryChanges: (0, _immutable.Map)()
}, _UITextInput.default.defaultProps);
var EMPTY_LIST = (0, _immutable.List)();
var propertiesToOmit = ['actions', 'wrappers', 'propertyInputComponentConfig', 'onTracking', 'isRequired'];

var getLinkHref = function getLinkHref(autolinker, domain) {
  var linker = autolinker.parse(domain);

  if (!linker || !linker[0]) {
    return domain;
  }

  return linker[0].getAnchorHref();
};

var PropertyInputMultiDomain =
/*#__PURE__*/
function (_React$Component) {
  (0, _inherits2.default)(PropertyInputMultiDomain, _React$Component);

  function PropertyInputMultiDomain(props) {
    var _this;

    (0, _classCallCheck2.default)(this, PropertyInputMultiDomain);
    _this = (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf2.default)(PropertyInputMultiDomain).call(this, props));
    (0, _ComponentMethods.bindHandlers)((0, _assertThisInitialized2.default)(_this));
    _this.partial = (0, _ComponentMethods.makePartial)();
    _this.renderDomain = _this.renderDomain.bind((0, _assertThisInitialized2.default)(_this));
    _this.state = {
      company: props.subject,
      hasBlurred: false
    };
    var config = _this.props.propertyInputComponentConfig;
    (0, _invariant.default)(config && config.Autolinker && config.Autolinker.parse, 'PropertyInputMultiDomain: Autolinker not defined');
    return _this;
  }

  (0, _createClass2.default)(PropertyInputMultiDomain, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.handleInitReferenceAtom();
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      if (this.referenceAtom) {
        (0, _atom.unwatch)(this.referenceAtom, this.handleCompanyReferenceChange);
      }
    }
  }, {
    key: "handleInitReferenceAtom",
    value: function handleInitReferenceAtom() {
      var _this$props = this.props,
          resolver = _this$props.resolver,
          subjectId = _this$props.subjectId,
          subject = _this$props.subject;

      if (subject) {
        return;
      }

      this.referenceAtom = resolver.byId(subjectId);
      (0, _atom.watch)(this.referenceAtom, this.handleCompanyReferenceChange);
      this.handleCompanyReferenceChange((0, _atom.deref)(this.referenceAtom));
    }
  }, {
    key: "handleCompanyReferenceChange",
    value: function handleCompanyReferenceChange(reference) {
      if (!(0, _utils.isResolved)(reference)) {
        return;
      }

      var company = reference.referencedObject;

      if (!company) {
        return;
      }

      this.setState({
        company: company
      });
    }
  }, {
    key: "handleShowPopover",
    value: function handleShowPopover() {
      return this.setState({
        open: !this.state.open
      });
    }
  }, {
    key: "focus",
    value: function focus() {
      if (this._domainInput) {
        this._domainInput.focus();

        return;
      }

      this.setState({
        open: true
      });
    }
  }, {
    key: "getValue",
    value: function getValue() {
      var _this$props2 = this.props,
          value = _this$props2.value,
          secondaryChanges = _this$props2.secondaryChanges;
      var company = this.state.company;
      var companyDomains = [value];

      if (!company || !company.has('additionalDomains')) {
        return companyDomains;
      }

      var removedDomains = secondaryChanges.get('hs_removed_domains') || EMPTY_LIST;
      return company.get('additionalDomains').reduce(function (acc, domainRecord) {
        var domain = domainRecord.get('domain');

        if (domain && !removedDomains.contains(domain) && companyDomains.indexOf(domain) === -1) {
          acc.push(domain);
        }

        return acc;
      }, companyDomains);
    }
  }, {
    key: "handleRemoveDomain",
    value: function handleRemoveDomain(domain) {
      var secondaryChanges = this.props.secondaryChanges;
      var removedDomains = secondaryChanges.get('hs_removed_domains') || EMPTY_LIST;
      this.setState({
        open: false
      });
      this.props.onSecondaryChange('hs_removed_domains', removedDomains.push(encodeURIComponent(domain)));
    }
  }, {
    key: "renderDomain",
    value: function renderDomain(domain) {
      return _react.default.createElement(_UITag.default, {
        key: domain,
        use: "default",
        closeable: true,
        onCloseClick: this.partial(this.handleRemoveDomain, domain)
      }, _react.default.createElement(_UILink.default, {
        href: getLinkHref(this.props.propertyInputComponentConfig.Autolinker, domain),
        external: true
      }, domain));
    }
  }, {
    key: "renderPopoverBody",
    value: function renderPopoverBody(domains) {
      var _this$props3 = this.props,
          autoFocus = _this$props3.autoFocus,
          objectType = _this$props3.objectType,
          onBlur = _this$props3.onBlur,
          onChange = _this$props3.onChange,
          onFocus = _this$props3.onFocus,
          onInvalidProperty = _this$props3.onInvalidProperty,
          onKeyUp = _this$props3.onKeyUp,
          property = _this$props3.property,
          readOnly = _this$props3.readOnly,
          subjectId = _this$props3.subjectId,
          value = _this$props3.value;
      return _react.default.createElement(_UIForm.default, null, _react.default.createElement(_UIFormControl.default, {
        label: _I18n.default.text('customerDataProperties.PropertyInputMultiDomain.primaryDomain')
      }, _react.default.createElement(_PropertyInputDomain.default, {
        autoFocus: autoFocus,
        isInline: false,
        objectType: objectType,
        onBlur: onBlur,
        onCancel: _emptyFunction.default,
        onChange: onChange,
        onFocus: onFocus,
        onInvalidProperty: onInvalidProperty,
        onKeyUp: onKeyUp,
        property: property,
        readOnly: readOnly,
        showError: true,
        subject: this.state.company,
        subjectId: subjectId,
        value: value
      })), _react.default.createElement(_UIFormControl.default, {
        label: _I18n.default.text('customerDataProperties.PropertyInputMultiDomain.secondaryDomain', {
          count: domains.length
        })
      }, _react.default.createElement(_UIList.default, {
        childClassName: "m-bottom-2"
      }, domains.map(this.renderDomain))));
    }
  }, {
    key: "renderInput",
    value: function renderInput(domains) {
      var _this2 = this;

      if (domains.length > 1) {
        return _react.default.createElement("span", {
          onClick: this.handleShowPopover
        }, _I18n.default.formatList(domains));
      }

      var transferrableProps = (0, _omit.default)(propertiesToOmit, this.props);
      return _react.default.createElement(_PropertyInputDomain.default, (0, _extends2.default)({
        ref: function ref(_ref) {
          return _this2._domainInput = _ref;
        }
      }, transferrableProps));
    }
  }, {
    key: "render",
    value: function render() {
      var _this3 = this;

      var domains = this.getValue();
      return _react.default.createElement(_UIGridItem.default, {
        size: {
          xs: 12
        },
        className: "p-x-0"
      }, _react.default.createElement(_UIPopover.default, {
        open: this.state.open,
        closeOnOutsideClick: true,
        onOpenChange: function onOpenChange(evt) {
          return _this3.setState({
            open: evt.target.value
          });
        },
        placement: "right",
        content: {
          body: this.renderPopoverBody(domains.slice(1))
        },
        width: 350
      }, this.renderInput(domains)));
    }
  }]);
  return PropertyInputMultiDomain;
}(_react.default.Component);

exports.default = PropertyInputMultiDomain;
PropertyInputMultiDomain.propTypes = propTypes;
PropertyInputMultiDomain.defaultProps = defaultProps;
module.exports = exports.default;